import { ShipmentStatus } from "@api/graphql/generated/generated-types";

interface ConfirmRouteTrigger {
  hasDriver: boolean;
  status: ShipmentStatus;
  hasNewStop: boolean;
  hasStopDateChange: boolean;
  hasPendingStopOrderChange: boolean;
}

const ACTIVE_STATUSES = new Set<ShipmentStatus>([
  ShipmentStatus.Assigned,
  ShipmentStatus.InTransit,
  ShipmentStatus.Routed,
]);

export function shouldOpenConfirmRoute({
  hasDriver,
  status,
  hasNewStop,
  hasStopDateChange,
  hasPendingStopOrderChange,
}: ConfirmRouteTrigger): boolean {
  return (
    hasDriver &&
    ACTIVE_STATUSES.has(status) &&
    (hasNewStop || hasStopDateChange || hasPendingStopOrderChange)
  );
}
